// Module
var code = "<div layout=\"row\" class=\"full-height\"> <md-icon md-svg-icon=\"spot\" class=\"bringoz-icon margin-0\"></md-icon> <span class=\"md-tiny\">{{$ctrl.orderPackages | orderSpots}}</span> </div> ";
// Exports
export default code;